export let Status = /*#__PURE__*/function (Status) {
  Status["Active"] = "active";
  Status["Archived"] = "archived";
  return Status;
}({});